// extracted by mini-css-extract-plugin
export default {"infoWrapper":"style_infoWrapper__qFFcG","infoTitle":"style_infoTitle__SB5dj","infoText":"style_infoText__7OBYi","alertTitle":"style_alertTitle__eUd67"};